<script setup lang="ts">
import { ref } from 'vue'
import { useRoute } from 'vue-router'

import { initWidget, StatscoreWidget } from '@collector/desktop-feature-widgets'
import { startLoader, stopLoader } from '@collector/shared-ui'
import { Env } from '@desktop/envs'

// composables
const route = useRoute()

// state
const isError = ref(false)

// data
const eventId = Number(route.params.eventId)

startLoader()

// methods
function handleLoaded(): void {
  stopLoader()
}

function handleError(): void {
  stopLoader()
  isError.value = true
}

initWidget(Env.VITE_WIDGETS_EMBEDDER_URL)
</script>

<template>
  <div class="flex h-screen w-screen justify-center">
    <div :class="{ 'w-[50vw]': !isError, 'w-screen': isError }">
      <StatscoreWidget
        v-show="!isError"
        :configurationId="Env.VITE_WIDGETS_LIVEMATCH_PRO_GROUP_ID"
        :eventId
        @widgetLoaded="handleLoaded"
        @widgetError="handleError"
      />
      <div v-show="isError">Error during loading Demo</div>
    </div>
  </div>
</template>
